import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Alert, AlertDescription, AlertTitle, Button } from '@brent/core-ui/ui'
import { X } from 'lucide-react'
import { useActiveSurvey } from '@/hooks/useSurveys'
import { useAuth } from '@/hooks/useAuth'

const DISMISS_KEY = 'survey-banner-dismissed'

export default function SurveyBanner() {
  const { isAuthenticated, hasGroup } = useAuth()
  const isMember = isAuthenticated && hasGroup('member')
  const { data: survey } = useActiveSurvey(isMember)
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === 'true')

  if (!isMember || !survey || dismissed) {
    return null
  }

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true')
    setDismissed(true)
  }

  return (
    <Alert className="mb-6 relative pr-12">
      <AlertTitle>Survey Available</AlertTitle>
      <AlertDescription className="flex flex-col sm:flex-row sm:items-center gap-2">
        <span className="flex-1">
          {survey.title}
          {survey.description
            ? ` — ${survey.description.slice(0, 80)}${survey.description.length > 80 ? '...' : ''}`
            : ''}
        </span>
        <Button asChild size="sm">
          <Link to="/survey">Take Survey</Link>
        </Button>
      </AlertDescription>
      <button
        onClick={handleDismiss}
        className="absolute top-3 right-3 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
        aria-label="Dismiss survey banner"
      >
        <X className="h-4 w-4" />
      </button>
    </Alert>
  )
}
